import { dispatch } from "d3";

export const surveyActions = {
  selectPatient,
  changeSurveyMode,
  initialiseSurveyPatient,
  storeSurveyedObj,
  storeDebugSurveyMode,
  storeActiveCase,
  updateSurveyForm,
  clearSurveyForm,
};

function selectPatientSucceeded(patient) {
  return {
    type: "SELECT_PATIENT_SUCCEEDED",
    payload: {
      patient: patient,
    },
  };
}

function selectPatient(patient) {
  return (dispatch) => {
    dispatch(selectPatientSucceeded(patient));
  };
}

function initialiseSurveyPatientSucceeded(patient) {
  return {
    type: "INITIALISE_SURVEY_PATIENT_SUCCEEDED",
    payload: {
      patient: patient,
    },
  };
}

function initialiseSurveyPatientWithSurveyModesSucceeded(patient) {
  return {
    type: "INITIALISE_SURVEY_PATIENT_WITH_SURVEY_MODES_SUCCEEDED",
    payload: {
      patient: patient,
    },
  };
}

function initialiseSurveyPatient(patient, debug_mode) {
  if (!debug_mode) {
    return (dispatch) => {
      dispatch(initialiseSurveyPatientWithSurveyModesSucceeded(patient));
    };
  } else {
    return (dispatch) => {
      dispatch(initialiseSurveyPatientSucceeded(patient));
    };
  }
}

function changeSurveyModeSucceeded(patient, mode) {
  return {
    type: "CHANGE_SURVEY_MODE_SUCCEEDED",
    payload: {
      patient: patient,
      survey_mode: mode,
    },
  };
}

function changeSurveyMode(patient, mode) {
  return (dispatch) => {
    dispatch(changeSurveyModeSucceeded(patient, mode));
  };
}

function updateSurveyFormSucceeded(form) {
  return {
    type: "UPDATE_SURVEY_FORM_SUCCEEDED",
    payload: { form }
  };
}

function updateSurveyForm(form) {
  return (dispatch) => {
    dispatch(updateSurveyFormSucceeded(form));
  };
}

function clearSurveyFormSucceeded() {
  return {
    type: "CLEAR_SURVEY_FORM_SUCCEEDED",
  };
}

function clearSurveyForm() {
  return (dispatch) => {
    dispatch(clearSurveyFormSucceeded());
  };
}

function storeSurveyedObjSucceeded(micro_id, case_id, patient_mrn, name, mode) {
  return {
    type: "STORE_SURVEYED_OBJ_SUCCEEDED",
    payload: {
      micro_id: micro_id,
      case_id: case_id,
      patient_mrn: patient_mrn,
      name: name,
      mode: mode,
    },
  };
}

function storeSurveyedObj(micro_id, case_id, patient_mrn, name, mode) {
  return (dispatch) => {
    dispatch(storeSurveyedObjSucceeded(micro_id, case_id, patient_mrn, name, mode));
  };
}

function storeDebugSurveyMode(mode) {
  return (dispatch) => {
    dispatch(storeDebugSurveyModeSucceeded(mode));
  };
}

function storeDebugSurveyModeSucceeded(mode) {
  return {
    type: "STORE_DEBUG_SURVEY_MODE_SUCCEEDED",
    payload: {
      debug_survey_mode: mode,
    },
  };
}

function storeActiveCaseSucceeded(activeCaseObj) {
    return {
      type: "STORE_ACTIVE_CASE_SUCCEEDED",
      payload: activeCaseObj,
    };
  }
  
function storeActiveCase({ micro_id, case_id, patient_mrn, patient_name, start_timestamp }) {
  return (dispatch) => {
    // dispatch the new active case
    dispatch(storeActiveCaseSucceeded({ micro_id, case_id, patient_mrn, patient_name, start_timestamp }));
  };
}